module.exports = __webpack_public_path__ + "754d5a47caa1744f6f7d2a9d99b4803c.png";